<template>
  <div>
    <VisualizationGraph :queries="queries" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VisualizationGraph from '@/components/VisualizationGraph.vue';
import queries from '@/queries.json';

export default defineComponent({
  components: { VisualizationGraph },
  data() {
    return { queries };
  },
});
</script>
